import { toast as reactHotToast } from 'react-hot-toast'
import { X, CircleX, Copy } from 'lucide-react'
import success from '../assets/images/Success.png'
export const useToast = () => {
	return {
		success: (message) => {
			reactHotToast.dismiss();
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex align-items-center'>
							<img src={success} className="img-fluid" alt="success" />
							<span>{message}</span>
						</div>
						<button
							className='closeToastBtn'
							onClick={() => reactHotToast.dismiss(t.id)}
						>
							<X color='white' size={15} />
						</button>
					</div>
				</div>
			))
		},
		error: (message) => {
			reactHotToast.dismiss();
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex align-items-center'>
							<CircleX color='red' />
							<span>{message || "Internal server Error."}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<X color='white' size={15} />
							</button>
						</div>
					</div>
				</div>
			))
		},
		copy: (message) => {
			reactHotToast.dismiss();
			reactHotToast((t) => (
				<div className='alertToast show'>
					<div className='d-flex justify-content-between align-items-center'>
						<div className='d-flex align-items-center'>
							<Copy color='white' size={20} />
							<span>{message}</span>
						</div>
						<div>
							<button
								className='closeToastBtn'
								onClick={() => reactHotToast.dismiss(t.id)}
							>
								<X color='white' size={15} />
							</button>
						</div>
					</div>
				</div>
			))
		},
	}
}
